import { render, staticRenderFns } from "./PantallaDatos.vue?vue&type=template&id=0b75c6e8"
import script from "./PantallaDatos.vue?vue&type=script&lang=js"
export * from "./PantallaDatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports